import { Link } from 'react-router-dom';

interface Breadcrumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  title: string;
  highlight?: string;
  subtitle?: string;
  bgImage: string;
  breadcrumbs?: Breadcrumb[];
}

export default function PageHero({ title, highlight, subtitle, bgImage, breadcrumbs }: PageHeroProps) {
  return (
    <section className="relative pt-36 pb-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={bgImage} alt={title} className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A2540]/92 via-[#0A2540]/80 to-[#071a2e]/90" />
        <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-[#3A86FF]/10 rounded-full blur-[80px]" />
        <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-[#3A86FF]/8 rounded-full blur-[100px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="flex items-center gap-2 text-white/50 text-sm mb-6 flex-wrap">
            {breadcrumbs.map((bc, i) => (
              <span key={bc.label} className="flex items-center gap-2">
                {i > 0 && (
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-xs" />
                  </span>
                )}
                {bc.to ? (
                  <Link
                    to={bc.to}
                    className="hover:text-[#3A86FF] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {bc.label}
                  </Link>
                ) : (
                  <span className="text-white/80 whitespace-nowrap">{bc.label}</span>
                )}
              </span>
            ))}
          </div>
        )}

        <div className="max-w-3xl">
          {subtitle && (
            <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-4">
              {subtitle}
            </span>
          )}
          <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight">
            {title}
            {highlight && (
              <>
                {' '}
                <span className="bg-gradient-to-r from-[#3A86FF] to-[#6aa3ff] bg-clip-text text-transparent">
                  {highlight}
                </span>
              </>
            )}
          </h1>
        </div>
      </div>
    </section>
  );
}
